import { getAPCAColor } from '../helpers/color';

export const useGetAPCAColor = (network) => {
  const { colors } = network?.advancedDesign?.theme || {};

  const { hasAdvancedDesign } = network;

  return getAPCAColor(hasAdvancedDesign, colors);
};
